import React, { useEffect, useRef, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { serverError } from "../../../../components/modals/payments/register/registerPaymentModal";
import { fecha } from "./expedienteLimpieza";

/*
	Descuentos › Limpieza: «¿Con quién va?» de una promo ligada (Esteban, 2026-10-27: el 50 % de 2do curso o 2da persona, el 2x1, los
	grupos y el referido se aplicaban sin decir con quién). Sugiere las otras matrículas de la misma persona, las que se matricularon
	juntas y su grupo si ya tiene; deja buscar a cualquiera; y el servidor revisa con las mismas reglas del paso Promoción (la base paga
	completo, una base da el 50 % a uno solo, tamaño y 15 días del grupo). Aplicar se habilita solo cuando no hay nada que corregir.
	Al revés (Esteban, 2026-10-27, caso Fany/Said SPS): en el 50 % y el 2x1 se puede decir que ESTA paga completo y la elegida es la que
	lleva la promo; entonces la vista previa es la de la elegida (que tiene que estar Por Revisar en la Limpieza).
	«Así Queda Cada Una» (Esteban, 2026-11-02, caso Karen/Emily SPS): una promo ligada se decide una vez para todas las tarjetas que une;
	antes de aplicar se ve qué le pasa a cada una (el servidor manda el mismo plan que aplicará: «together»).
*/

const http = HttpManager.getInstance();

const PREGUNTA: Record<string, string> = {
	segundo: "¿Con quién va el 50 %? Elige la matrícula que paga completo: su otro curso u otra persona.",
	dos_x_uno: "¿Cuál curso se paga? Elige la base del 2x1 (paga completo; este curso es el regalado).",
	referido_por: "¿Quién lo refirió? Elige una matrícula de esa persona.",
};
const PREGUNTA_REVES: Record<string, string> = {
	segundo: "¿Quién lleva el 50 %? Elige su matrícula: su otro curso u otra persona.",
	dos_x_uno: "¿Cuál es el curso regalado? Elige esa matrícula; este curso es el que se paga.",
};

const num = (n: number) => (Math.round(n * 100) / 100).toLocaleString("es-MX", { maximumFractionDigits: 2 });

type Junta = { key: string; name: string; courseName?: string; rol: string; como: "promo" | "completo" | "pendiente" | "nada"; pv?: any; reason?: string | null };

const VinculoLimpieza: React.FC<{ campusId: number; cleanupId: number; promotionId: number; linkType: string; groupSize: number | null; promoName: string;
	nombre: string; nombreCompleto: string; cursoEsta?: string; previaEsta: any; sym: string; tabla: (pv: any) => React.ReactNode;
	onChange: (ids: number[], ok: boolean, alReves: boolean, otra: any, juntas: any[]) => void }> =
	({ campusId, cleanupId, promotionId, linkType, groupSize, promoName, nombre, nombreCompleto, cursoEsta, previaEsta, sym, tabla, onChange }) => {
	const varios = linkType === "grupo";
	const puedeAlReves = linkType === "segundo" || linkType === "dos_x_uno";
	const [alReves, setAlReves] = useState(false);
	const [previaOtra, setPreviaOtra] = useState<any>(null);
	const [q, setQ] = useState("");
	const [data, setData] = useState<any>(null);
	const [sel, setSel] = useState<Record<number, any>>({});
	const [cargando, setCargando] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const primera = useRef(true);

	const ids = Object.keys(sel).map(Number);
	useEffect(() => {
		const t = setTimeout(() => {
			setCargando(true);
			http.paymentService.cleanupLinks(campusId, cleanupId, q, promotionId, ids, alReves).then((r: any) => {
				setData(r.data);
				setError(null);
				// Grupo que ya existe: sus miembros van marcados de entrada.
				if (primera.current) {
					primera.current = false;
					if (varios) {
						const ya = (r.data.suggestions || []).filter((s: any) => s.why === "Ya está en su grupo");
						if (ya.length) setSel(Object.fromEntries(ya.map((s: any) => [s.enrollmentId, s])));
					}
				}
			}).catch((e: any) => setError(serverError(e))).finally(() => setCargando(false));
		}, q ? 300 : 0);
		return () => clearTimeout(t);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId, cleanupId, promotionId, q, ids.join(","), alReves]);

	const issues: string[] = data?.issues || [];
	const otra = ids.length === 1 ? sel[ids[0]] : null;
	const together: any[] = !alReves && ids.length && !cargando ? data?.together || [] : [];
	useEffect(() => {
		onChange(ids, ids.length > 0 && !cargando && !error && issues.length === 0, alReves, otra, together);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ids.join(","), cargando, error, issues.join("|"), alReves, together.map((t) => t.enrollmentId + t.action).join(",")]);
	// Al revés: cómo quedaría la elegida con la promo (su propia vista previa de Limpieza).
	useEffect(() => {
		setPreviaOtra(null);
		if (!alReves || !otra?.cleanupId) return;
		let vivo = true;
		http.paymentService.cleanupItem(campusId, otra.cleanupId, promotionId).then((r: any) => { if (vivo) setPreviaOtra(r.data?.preview || null); })
			.catch((e: any) => { if (vivo) setError(serverError(e)); });
		return () => { vivo = false; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [alReves, otra?.cleanupId, promotionId, campusId]);
	const voltear = (v: boolean) => { if (v !== alReves) { setSel({}); setAlReves(v); } };

	const elegir = (v: any) => setSel((s) => {
		if (s[v.enrollmentId]) {
			const n = { ...s };
			delete n[v.enrollmentId];
			return n;
		}
		return varios ? { ...s, [v.enrollmentId]: v } : { [v.enrollmentId]: v };
	});
	const fila = (v: any) => (
		<label key={"v" + v.enrollmentId} className={"wdVinculo" + (sel[v.enrollmentId] ? " wdVinculoOn" : "")}>
			<input type={varios ? "checkbox" : "radio"} checked={!!sel[v.enrollmentId]} onChange={() => elegir(v)} />
			<span style={{ minWidth: 0 }}>
				<b>{v.name}</b> · {v.courseName}{v.campusId !== campusId ? " · " + v.campusName : ""}
				<span className="wdTenue"> · Matriculada el {fecha(v.enrolledAt)}</span>
				<span className="wdChips" style={{ marginTop: 2 }}>
					{v.why ? <span className="wdChip wdChipAcento">{v.why}</span> : null}
					{v.agreement ? <span className="wdChip wdChipFilo">{v.agreement}</span> : <span className="wdChip wdChipFilo">Sin acuerdo</span>}
					{v.group ? <span className="wdChip wdChipOro">{v.group.kindName}: {v.group.members.join(", ")}</span> : null}
					{v.inCleanup ? <span className="wdChip wdChipFilo">También en Limpieza</span> : null}
				</span>
			</span>
		</label>
	);

	// Una tarjeta por persona: esta primero (o la elegida, al revés), luego las que la promo une.
	const juntas: Junta[] = [];
	if (alReves) {
		if (otra && previaOtra && !issues.length) {
			juntas.push({ key: "o" + otra.enrollmentId, name: otra.name, courseName: otra.courseName, rol: linkType === "segundo" ? "Lleva el 50 %" : "Curso Regalado", como: "promo",
				pv: { ...previaOtra, months: previaOtra.months.map((x: any) => ({ ...x, effect: x.effect === "subiria" ? "igual" : x.effect })) } });
			juntas.push({ key: "esta", name: nombreCompleto, courseName: cursoEsta, rol: "Esta Tarjeta", como: "completo" });
		}
	} else {
		juntas.push({ key: "esta", name: nombreCompleto, courseName: cursoEsta, rol: "Esta Tarjeta", como: "promo", pv: previaEsta });
		for (const t of together) {
			juntas.push({ key: "t" + t.enrollmentId, name: t.name, courseName: t.courseName, rol: t.role === "base" ? "Paga Completo" : "Mismo Grupo",
				como: t.action === "promo" ? "promo" : t.action === "sinPromo" ? "completo" : t.pending ? "pendiente" : "nada",
				pv: t.action === "promo" && t.preview ? { ...t.preview, months: t.preview.months.map((x: any) => ({ ...x, effect: x.effect === "subiria" ? "igual" : x.effect })) } : null,
				reason: t.reason });
		}
	}
	const resumen = (pv: any) => {
		const bajan = (pv.months || []).filter((x: any) => x.effect === "baja");
		const menos = bajan.reduce((acc: number, x: any) => acc + (x.before || 0) - (x.after || 0), 0);
		return bajan.length ? bajan.length + (bajan.length === 1 ? " mes más barato" : " meses más baratos") + " · " + sym + num(menos) + " menos" : "Ningún mes cambia";
	};
	const junta = (j: Junta) => (
		<div key={j.key} className={"wdJunta" + (j.como === "promo" ? " wdJuntaPromo" : j.como === "pendiente" ? " wdJuntaPendiente" : "")}>
			<div className="wdJuntaCab">
				<b>{j.name}</b>{j.courseName ? <span className="wdTenue">{j.courseName}</span> : null}
				{j.como !== "completo" ? <span className="wdChip wdChipFilo">{j.rol}</span> : null}
				{j.como === "promo" ? <span className="wdChip wdChipAcento">{(j.pv?.promoName || promoName)}</span>
					: j.como === "completo" ? <span className="wdChip wdChipFilo">{j.rol === "Esta Tarjeta" ? "Esta Tarjeta · " : ""}Base · Paga Completo</span>
					: j.como === "pendiente" ? <span className="wdChip wdChipOro">Sigue Por Revisar</span> : <span className="wdChip wdChipFilo">No Se Toca</span>}
			</div>
			{j.como === "promo" && j.pv ? (
				<>
					<div className="wdJuntaLinea">{resumen(j.pv)}{j.pv.conditions?.text ? " · " + j.pv.conditions.text : ""}</div>
					<details className="wdJuntaMeses" open={j.key === "esta" && juntas.length === 1}><summary>Mes por Mes</summary>{tabla(j.pv)}</details>
				</>
			) : j.como === "promo" ? <div className="wdJuntaLinea wdTenue">Calculando…</div>
				: j.como === "completo" ? <div className="wdJuntaLinea">Ningún mes cambia; queda ligada como base de {juntas.filter((x) => x.como === "promo").map((x) => x.name.split(" ")[0]).join(", ") || "la otra"}</div>
				: <div className={"wdJuntaLinea" + (j.como === "pendiente" ? " wdOro" : " wdTenue")}>{j.reason}</div>}
		</div>
	);

	const sug = data?.suggestions || [];
	const res = (data?.results || []).filter((v: any) => !sug.some((s: any) => s.enrollmentId === v.enrollmentId));
	return (
		<div className="wdVinculos">
			{puedeAlReves ? (
				<div className="wdSub" style={{ marginTop: 6, display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center" }}>
					<span>{linkType === "segundo" ? "¿Quién lleva el 50 %?" : "¿Cuál es el curso regalado?"}</span>
					<label className={"wdVinculo" + (!alReves ? " wdVinculoOn" : "")} style={{ margin: 0 }}>
						<input type="radio" checked={!alReves} onChange={() => voltear(false)} />{linkType === "segundo" ? nombre + " (esta tarjeta)" : "Este curso de " + nombre}</label>
					<label className={"wdVinculo" + (alReves ? " wdVinculoOn" : "")} style={{ margin: 0 }}>
						<input type="radio" checked={alReves} onChange={() => voltear(true)} />{linkType === "segundo" ? "La otra persona o su otro curso: " + nombre + " paga completo" : "El otro curso: este se paga completo"}</label>
				</div>
			) : null}
			<div className="wdSub" style={{ marginTop: 6 }}>{varios ? "¿Quiénes más van en el grupo? «" + promoName + "» pide " + (groupSize || "varias") + " personas en total, contando a esta." : (alReves ? PREGUNTA_REVES[linkType] : PREGUNTA[linkType]) || "¿Con quién va?"}</div>
			{data?.ownGroup ? <div className="wdTenue" style={{ fontSize: 13 }}>Esta matrícula ya está en un «{data.ownGroup.kindName}» como {String(data.ownGroup.roleName).toLowerCase()}.</div> : null}
			{sug.length ? sug.map(fila) : data ? <div className="wdTenue" style={{ fontSize: 13 }}>No tiene otros cursos ni personas matriculadas con ella; búscala abajo.</div> : null}
			<input className="form-control form-control-sm" style={{ maxWidth: 420, margin: "6px 0" }} value={q} onChange={(e) => setQ(e.target.value)}
				placeholder="Buscar otra persona: nombre, correlativo o teléfono" aria-label="Buscar con quién va" />
			{q.trim().length >= 2 ? (res.length ? res.map(fila) : !cargando ? <div className="wdTenue" style={{ fontSize: 13 }}>Nadie con ese nombre en matrículas activas.</div> : null) : null}
			{ids.length && !varios ? null : varios && ids.length ? <div className="wdTenue" style={{ fontSize: 13 }}>Elegidas: {Object.values(sel).map((v: any) => v.name).join(", ")}</div> : null}
			{error ? <div className="wdAviso">{error}</div> : null}
			{issues.length ? <div className="wdAviso">{issues.map((x, i) => <div key={"i" + i}>{x}</div>)}</div> : null}
			{cargando ? <div className="wdTenue" style={{ fontSize: 12 }}>Revisando…</div> : null}
			{juntas.length ? (
				<div className="wdJuntas">
					<div className="wdSub" style={{ margin: "6px 0 0 0" }}>Así Queda Cada Una{juntas.length > 1 ? " (" + juntas.length + ")" : ""}</div>
					{juntas.map(junta)}
				</div>
			) : null}
		</div>
	);
};

export default VinculoLimpieza;
